(function(){
    // ---- Toast ----
    var toast = document.getElementById('toast'), tT;
    function showToast(msg, durationMs){
      if(!toast || !msg) return;
      toast.textContent = msg;
      toast.classList.add('show');
      clearTimeout(tT);
      tT = setTimeout(function(){ toast.classList.remove('show'); }, durationMs || 2500);
    }
    window.showToast = showToast;

    // ---- Cart (AJAX) ----
    function updateCartBadges(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function(b){ 
        b.textContent = count; 
        b.style.display = count > 0 ? 'flex' : 'none'; 
      });
    }

    // ---- Cart stock sync (remove OOS / clamp qty to inventory) ----
    // Shopify keeps sold-out / oversold lines in the cart until checkout.
    // This reconciles against live product inventory before drawer/checkout.
    var productCache = {};
    var variantStockMap = {};
    var reconcileInFlight = null;

    function decodeAttr(str) {
      if (!str) return '';
      return String(str)
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#0*39;|&apos;/g, "'")
        .replace(/&#(\d+);/g, function(_, num) {
          var n = parseInt(num, 10);
          return isNaN(n) ? '' : String.fromCharCode(n);
        })
        .replace(/&#x([0-9a-fA-F]+);/g, function(_, hex) {
          var n = parseInt(hex, 16);
          return isNaN(n) ? '' : String.fromCharCode(n);
        });
    }

    function stockLabel(key, fallback) {
      var root = document.getElementById('ramCartDrawer');
      if (root) {
        var v = root.getAttribute('data-label-' + key);
        if (v) return decodeAttr(v);
      }
      var seed = document.getElementById('ramCartStockConfig');
      if (seed) {
        try {
          var cfg = JSON.parse(seed.textContent);
          if (cfg && cfg[key]) return decodeAttr(cfg[key]);
        } catch (e) {}
      }
      return fallback;
    }

    function allowedQtyForVariant(itemQty, variant) {
      if (!variant) return itemQty;
      var tracked = !!(variant.inventory_management);
      var policy = variant.inventory_policy || 'deny';
      if (!tracked || policy === 'continue') return itemQty;
      if (variant.available === false) return 0;
      if (typeof variant.inventory_quantity === 'number') {
        return Math.min(itemQty, Math.max(0, variant.inventory_quantity));
      }
      return variant.available ? itemQty : 0;
    }

    function maxQtyForVariant(variant) {
      if (!variant) return Infinity;
      var tracked = !!(variant.inventory_management);
      var policy = variant.inventory_policy || 'deny';
      if (!tracked || policy === 'continue') return Infinity;
      if (variant.available === false) return 0;
      if (typeof variant.inventory_quantity === 'number') {
        return Math.max(0, variant.inventory_quantity);
      }
      return Infinity;
    }

    function mergeVariantStock(map) {
      if (!map) return;
      Object.keys(map).forEach(function(id) {
        variantStockMap[id] = mergeStockRow(variantStockMap[id], map[id]);
      });
    }

    function variantStockForId(id) {
      if (id == null) return null;
      return variantStockMap[String(id)] || null;
    }

    function fetchProductByHandle(handle) {
      if (!handle) return Promise.resolve(null);
      if (productCache[handle]) return productCache[handle];
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() {
          delete productCache[handle];
          return null;
        });
      return productCache[handle];
    }

    function coerceQty(value) {
      if (typeof value === 'number' && isFinite(value)) return value;
      var n = parseInt(value, 10);
      return isNaN(n) ? undefined : n;
    }

    function parseStockSeedJson(text) {
      var map = {};
      if (!text) return map;
      try {
        var rows = JSON.parse(text);
        (rows || []).forEach(function(row) {
          if (!row || row.variant_id == null) return;
          map[String(row.variant_id)] = {
            available: row.available,
            inventory_quantity: coerceQty(row.inventory_quantity),
            inventory_management: row.inventory_management,
            inventory_policy: row.inventory_policy,
            title: row.title
          };
        });
      } catch (e) {}
      return map;
    }

    function mergeStockRow(prev, next) {
      prev = prev || {};
      next = next || {};
      var nextQty = coerceQty(next.inventory_quantity);
      return {
        available: next.available != null ? next.available : prev.available,
        inventory_quantity: typeof nextQty === 'number'
          ? nextQty
          : prev.inventory_quantity,
        inventory_management: next.inventory_management != null
          ? next.inventory_management
          : prev.inventory_management,
        inventory_policy: next.inventory_policy != null
          ? next.inventory_policy
          : prev.inventory_policy,
        title: next.title || prev.title
      };
    }

    function seedVariantMap() {
      var el = document.getElementById('ramCartStockSeed');
      var map = parseStockSeedJson(el && el.textContent);
      Object.keys(variantStockMap).forEach(function(id) {
        map[id] = mergeStockRow(map[id], variantStockMap[id]);
      });
      return map;
    }

    mergeVariantStock(seedVariantMap());
    (function seedPdpVariantStock() {
      var el = document.getElementById('pdpVariants');
      if (!el) return;
      try {
        var rows = JSON.parse(el.textContent);
        var map = {};
        (rows || []).forEach(function(v) {
          if (!v || v.id == null) return;
          map[String(v.id)] = {
            available: v.available,
            inventory_quantity: v.inventory_quantity,
            inventory_management: v.inventory_management,
            inventory_policy: v.inventory_policy
          };
        });
        mergeVariantStock(map);
      } catch (e) {}
    })();

    function parseStockSeedFromHtml(html) {
      if (!html) return {};
      var match = html.match(/<script[^>]+id=["']ramCartStockSeed["'][^>]*>([\s\S]*?)<\/script>/i);
      if (!match || !match[1]) return {};
      var live = document.getElementById('ramCartStockSeed');
      if (live) live.textContent = match[1];
      return parseStockSeedJson(match[1]);
    }

    var stockSeedRefresh = null;
    function refreshStockSeedFromSection() {
      if (stockSeedRefresh) return stockSeedRefresh;
      var url;
      try {
        url = new URL(window.location.href);
        url.searchParams.set('section_id', 'ram-cart-drawer');
      } catch (e) {
        url = '/?section_id=ram-cart-drawer';
      }
      stockSeedRefresh = fetch(String(url), { headers: { Accept: 'text/html' } })
        .then(function(r) { return r.ok ? r.text() : ''; })
        .then(function(html) {
          if (!html) return;
          mergeVariantStock(parseStockSeedFromHtml(html));
        })
        .catch(function() {})
        .finally(function() { stockSeedRefresh = null; });
      return stockSeedRefresh;
    }

    function reconcileCartStock(existingCart) {
      if (reconcileInFlight) return reconcileInFlight;
      var cartPromise = (existingCart && existingCart.items)
        ? Promise.resolve(existingCart)
        : fetch('/cart.js').then(function(r) { return r.json(); });

      reconcileInFlight = cartPromise
        .then(function(cart) {
          var items = (cart.items || []).filter(function(i) { return i && i.quantity > 0; });
          if (!items.length) {
            return { cart: cart, changed: false, removed: 0, reduced: 0 };
          }

          var seed = seedVariantMap();
          var missingHandles = {};
          items.forEach(function(item) {
            var vid = String(item.variant_id || item.id);
            var st = seed[vid] || variantStockMap[vid];
            if (!st || typeof st.inventory_quantity !== 'number') {
              if (item.handle) missingHandles[item.handle] = true;
            }
          });

          var handleList = Object.keys(missingHandles);
          var productsPromise = handleList.length
            ? Promise.all(handleList.map(fetchProductByHandle))
            : Promise.resolve([]);

          return productsPromise.then(function(products) {
            var byVariant = {};
            Object.keys(seed).forEach(function(id) { byVariant[id] = seed[id]; });
            products.forEach(function(product) {
              if (!product || !product.variants) return;
              product.variants.forEach(function(v) {
                var id = String(v.id);
                var prev = byVariant[id] || variantStockMap[id] || {};
                byVariant[id] = mergeStockRow(prev, {
                  available: v.available,
                  inventory_quantity: v.inventory_quantity,
                  inventory_management: v.inventory_management,
                  inventory_policy: v.inventory_policy,
                  title: product.title
                });
              });
            });
            mergeVariantStock(byVariant);

            var updates = {};
            var removed = 0;
            var reduced = 0;
            items.forEach(function(item) {
              var variant = byVariant[String(item.variant_id)] || byVariant[String(item.id)];
              var allowed = allowedQtyForVariant(item.quantity, variant);
              if (allowed !== item.quantity) {
                updates[item.key] = allowed;
                if (allowed === 0) removed += 1;
                else reduced += 1;
              }
            });

            if (!Object.keys(updates).length) {
              return { cart: cart, changed: false, removed: 0, reduced: 0 };
            }

            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates, sections: 'ram-cart-drawer' })
            })
            .then(function(r) {
              return r.json().then(function(data) {
                if (!r.ok) throw data;
                return data;
              });
            })
            .then(function(nextCart) {
              if (nextCart.sections && nextCart.sections['ram-cart-drawer']) {
                mergeVariantStock(parseStockSeedFromHtml(nextCart.sections['ram-cart-drawer']));
              }
              updateCartBadges(nextCart.item_count);
              return { cart: nextCart, changed: true, removed: removed, reduced: reduced };
            });
          });
        })
        .catch(function(err) {
          return { cart: existingCart || { item_count: 0, items: [] }, changed: false, removed: 0, reduced: 0, error: err };
        })
        .finally(function() { reconcileInFlight = null; });

      return reconcileInFlight;
    }

    function notifyStockChanges(result) {
      if (!result || !result.changed) return;
      var msg;
      if (result.removed && result.reduced) {
        msg = stockLabel('stock-adjusted', 'Cart updated: unavailable items were removed or reduced.');
      } else if (result.removed) {
        msg = stockLabel('stock-removed', 'Unavailable items were removed from your cart.');
      } else {
        msg = stockLabel('stock-reduced', 'Some quantities were reduced to match available stock.');
      }
      showToast(msg);
    }

    window.ramReconcileCartStock = reconcileCartStock;

    // Cart page inline script runs before deferred ramillette.js — sync here instead.
    if (document.body && document.body.classList.contains('template-cart')) {
      reconcileCartStock().then(function(result) {
        if (result && result.changed) window.location.reload();
      });
    }

    // ---- Cart drawer ----
    var ramCartDrawer = (function() {
      var root = document.getElementById('ramCartDrawer');
      if (!root) return null;

      var STORAGE_PENDING = 'ram_pending_discount';
      var STORAGE_OPEN = 'ram_open_drawer';
      var itemsEl = root.querySelector('[data-cart-drawer-items]');
      var emptyEl = root.querySelector('[data-cart-drawer-empty]');
      var footEl = root.querySelector('[data-cart-drawer-foot]');
      var countEl = root.querySelector('[data-cart-drawer-count]');
      var subtotalEl = root.querySelector('[data-cart-drawer-subtotal]');
      var savingsRow = root.querySelector('[data-cart-drawer-savings]');
      var savingsAmountEl = root.querySelector('[data-cart-drawer-savings-amount]');
      var savingsLabelEl = root.querySelector('[data-cart-drawer-savings-label]');
      var totalRow = root.querySelector('[data-cart-drawer-total-row]');
      var totalEl = root.querySelector('[data-cart-drawer-total]');
      var compareEl = root.querySelector('[data-cart-drawer-compare]');
      var discountAppliedEl = root.querySelector('[data-cart-drawer-discount-applied]');
      var discountFormEl = root.querySelector('[data-cart-drawer-discount-form]');
      var discountInput = document.getElementById('drawerDiscountCode');
      var discountBtn = document.getElementById('drawerDiscountApply');
      var discountError = document.getElementById('drawerDiscountError');
      var checkoutEl = root.querySelector('[data-cart-drawer-checkout]');
      var checkoutLabelEl = root.querySelector('[data-cart-drawer-checkout-label]');
      var thresholdBar = root.querySelector('[data-cart-threshold-bar]');
      var thresholdMsg = root.querySelector('[data-cart-threshold-msg]');
      var thresholdSteps = root.querySelectorAll('[data-cart-threshold-step]');
      var thresholdConfetti = root.querySelector('[data-cart-threshold-confetti]');
      var thresholdCelebrated = false;
      var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
      var labelItem = decodeAttr(root.getAttribute('data-label-item')) || 'item';
      var labelItems = decodeAttr(root.getAttribute('data-label-items')) || 'items';
      var labelEach = decodeAttr(root.getAttribute('data-label-each')) || 'each';
      var labelInvalid = decodeAttr(root.getAttribute('data-label-invalid')) || 'That code is invalid or expired.';
      var labelCheckout = decodeAttr(root.getAttribute('data-label-checkout')) || 'Checkout Now';
      var labelCheckoutUnlocked = decodeAttr(root.getAttribute('data-label-checkout-unlocked')) || 'Checkout with 10% off';
      var labelYouSaved = decodeAttr(root.getAttribute('data-label-you-saved')) || 'You saved';
      var labelOfferUnlocked = decodeAttr(root.getAttribute('data-label-offer-unlocked')) || 'Offer unlocked!';
      var labelCodeApplied = decodeAttr(root.getAttribute('data-label-code-applied')) || 'Code Applied';
      var shopUrl = root.getAttribute('data-shop-url') || '';
      var themeId = root.getAttribute('data-theme-id') || '';
      var themeRole = root.getAttribute('data-theme-role') || '';
      var syncing = false;
      var pending = {};
      var timer = null;
      var pendingThresholdToast = null;
      var lastCartFingerprint = '';
      var THRESHOLD_TOAST_PREFIX = 'ram_threshold_toast_';
      var CODE_CHECK_SVG_INNER =
        '<path d="M1 8.14312L3.4 10.5L9 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M8.38184 9.5L9.39996 10.5L15 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
      var TRASH_SVG =
        '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m2 0v12a2 2 0 01-2 2H8a2 2 0 01-2-2V7h12zM10 11v6M14 11v6"/></svg>';

      function codeCheckSvg(id) {
        return '<svg class="ram-cart-drawer-code-check" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
          '<g clip-path="url(#' + id + ')">' + CODE_CHECK_SVG_INNER + '</g>' +
          '<defs><clipPath id="' + id + '"><rect width="16" height="16" fill="white"/></clipPath></defs>' +
        '</svg>';
      }

      function cartImageUrl(url) {
        if (!url) return '';
        try {
          var u = new URL(url, window.location.origin);
          u.searchParams.set('width', '144');
          return u.href;
        } catch (e) {
          return url;
        }
      }

      function cartFingerprint(cart) {
        if (!cart || !cart.items) return '0';
        return cart.item_count + ':' + cart.total_price + ':' + (cart.total_discount || 0) + ':' +
          cart.items.map(function(i) { return i.key + '=' + i.quantity; }).join('|');
      }

      function qtyCtrlHtml(qty, maxQty) {
        var atMax = isFinite(maxQty) && qty >= maxQty;
        return '<div class="ram-cart-drawer-ctrl" role="group" aria-label="Quantity">' +
          (qty <= 1
            ? ('<button type="button" class="ram-cart-drawer-line-remove" data-drawer-remove aria-label="Remove">' + TRASH_SVG + '</button>')
            : '<button type="button" class="ram-cart-drawer-qty-minus" data-drawer-minus aria-label="Decrease">−</button>'
          ) +
          '<span class="ram-cart-drawer-ctrl-divider" aria-hidden="true"></span>' +
          '<span class="ram-cart-drawer-qty-val" data-drawer-qty-display>' + qty + '</span>' +
          '<span class="ram-cart-drawer-ctrl-divider" aria-hidden="true"></span>' +
          '<button type="button" class="ram-cart-drawer-qty-plus" data-drawer-plus aria-label="Increase"' +
            (atMax ? ' disabled aria-disabled="true"' : '') +
          '>+</button>' +
        '</div>';
      }

      function maxQtyForItem(item) {
        if (!item) return Infinity;
        return maxQtyForVariant(variantStockForId(item.variant_id) || variantStockForId(item.id));
      }

      function lineMaxQty(lineEl) {
        if (!lineEl) return Infinity;
        var raw = lineEl.getAttribute('data-max-qty');
        if (raw === '' || raw == null) {
          return maxQtyForVariant(variantStockForId(lineEl.getAttribute('data-variant-id')));
        }
        var n = parseInt(raw, 10);
        return isNaN(n) ? Infinity : n;
      }

      function setLineMaxQty(lineEl, maxQty) {
        if (!lineEl) return;
        if (isFinite(maxQty)) lineEl.setAttribute('data-max-qty', String(maxQty));
        else lineEl.removeAttribute('data-max-qty');
      }

      function updatePlusState(lineEl, qty, maxQty) {
        var plus = lineEl && lineEl.querySelector('[data-drawer-plus]');
        if (!plus) return;
        var atMax = isFinite(maxQty) && qty >= maxQty;
        plus.disabled = atMax;
        if (atMax) plus.setAttribute('aria-disabled', 'true');
        else plus.removeAttribute('aria-disabled');
      }

      function applyStockLimitsToLines(cart) {
        if (!itemsEl) return;
        var items = (cart && cart.items) || [];
        var lines = itemsEl.querySelectorAll('.ram-cart-drawer-line');
        Array.prototype.forEach.call(lines, function(lineEl) {
          var key = lineEl.getAttribute('data-key');
          var item = null;
          for (var i = 0; i < items.length; i++) {
            if (items[i].key === key) { item = items[i]; break; }
          }
          var qty = item ? item.quantity : (parseInt(lineEl.getAttribute('data-qty'), 10) || 0);
          var maxQty = item ? maxQtyForItem(item) : maxQtyForVariant(variantStockForId(lineEl.getAttribute('data-variant-id')));
          setLineMaxQty(lineEl, maxQty);
          updatePlusState(lineEl, qty, maxQty);
        });
      }

      function groupThousands(intStr) {
        return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents, moneyFormat);
        }
        var amount = (Number(cents) / 100).toFixed(2);
        var parts = amount.split('.');
        var pretty = groupThousands(parts[0]) + '.' + parts[1];
        return moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, pretty)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, groupThousands(String(Math.round(Number(cents) / 100))));
      }

      function escapeHtml(str) {
        return String(str == null ? '' : str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function discountRedirectBase() {
        var redirect = window.location.pathname + window.location.search;
        if (themeRole === 'development' || themeRole === 'unpublished') {
          redirect += (redirect.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + themeId;
        }
        return redirect;
      }

      function applyDiscountCode(code) {
        code = (code || '').trim();
        if (!code) {
          if (discountInput) discountInput.focus();
          return;
        }
        if (discountBtn) {
          discountBtn.disabled = true;
          discountBtn.textContent = discountBtn.getAttribute('data-label-applying') || discountBtn.textContent;
        }
        try {
          sessionStorage.setItem(STORAGE_PENDING, code);
          sessionStorage.setItem(STORAGE_OPEN, '1');
        } catch (e) {}
        window.location.href = shopUrl + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(discountRedirectBase());
      }

      function open() {
        if (!root.classList.contains('is-open')) {
          root.hidden = false;
          root.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(function() { root.classList.add('is-open'); });
          document.body.classList.add('ram-cart-drawer-open');
        } else {
          root.hidden = false;
          root.setAttribute('aria-hidden', 'false');
          document.body.classList.add('ram-cart-drawer-open');
        }
      }

      function close() {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ram-cart-drawer-open');
        setTimeout(function() {
          if (!root.classList.contains('is-open')) root.hidden = true;
        }, 280);
        flushPendingThresholdToast();
      }

      function fillTemplate(tpl, vars) {
        return decodeAttr(tpl).replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, key) {
          return vars[key] != null ? String(vars[key]) : '';
        });
      }

      function thresholdConfig() {
        if (!thresholdBar) return null;
        var startAt = parseInt(thresholdBar.getAttribute('data-start-at'), 10);
        var endAt = parseInt(thresholdBar.getAttribute('data-end-at'), 10);
        var now = Date.now();
        if (startAt && !isNaN(startAt) && now < startAt) return null;
        if (endAt && !isNaN(endAt) && now >= endAt) return null;
        if (thresholdBar.getAttribute('data-active') === 'false') return null;
        var threshold = parseInt(thresholdBar.getAttribute('data-threshold'), 10);
        var percent = parseInt(thresholdBar.getAttribute('data-percent'), 10) || 10;
        if (!threshold || isNaN(threshold)) return null;
        return { threshold: threshold, percent: percent, endAt: endAt };
      }

      function toastSeen(key) {
        try { return sessionStorage.getItem(THRESHOLD_TOAST_PREFIX + key) === '1'; } catch (e) { return false; }
      }

      function markToastSeen(key) {
        try { sessionStorage.setItem(THRESHOLD_TOAST_PREFIX + key, '1'); } catch (e) {}
      }

      function queueOrShowThresholdToast(key, msg) {
        if (!msg || toastSeen(key)) return;
        markToastSeen(key);
        if (root.classList.contains('is-open')) {
          pendingThresholdToast = msg;
        } else {
          showToast(msg, 3000);
        }
      }

      function flushPendingThresholdToast() {
        if (!pendingThresholdToast) return;
        var msg = pendingThresholdToast;
        pendingThresholdToast = null;
        setTimeout(function() { showToast(msg, 3000); }, 320);
      }

      function setCheckoutLabel(text) {
        if (checkoutLabelEl) checkoutLabelEl.textContent = text;
        else if (checkoutEl) {
          var arrow = checkoutEl.querySelector('.ram-cart-drawer-checkout-arrow');
          checkoutEl.textContent = '';
          var span = document.createElement('span');
          span.setAttribute('data-cart-drawer-checkout-label', '');
          span.textContent = text;
          checkoutLabelEl = span;
          checkoutEl.appendChild(span);
          if (arrow) checkoutEl.appendChild(arrow);
          else {
            var a = document.createElement('span');
            a.className = 'ram-cart-drawer-checkout-arrow';
            a.setAttribute('aria-hidden', 'true');
            a.textContent = '›';
            checkoutEl.appendChild(a);
          }
        }
      }

      function fireConfetti() {
        if (!thresholdConfetti) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        thresholdConfetti.innerHTML = '';
        var pieces = ['🎉', '✨', '🎊', '⭐'];
        var count = 10;
        var frag = document.createDocumentFragment();
        for (var i = 0; i < count; i++) {
          var span = document.createElement('span');
          span.className = 'ram-confetti-piece';
          span.textContent = pieces[i % pieces.length];
          var angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.6;
          var distance = 30 + Math.random() * 26;
          var tx = Math.cos(angle) * distance;
          var ty = Math.sin(angle) * distance - 12;
          var rot = (Math.random() * 240 - 120) + 'deg';
          span.style.setProperty('--ram-tx', tx.toFixed(1) + 'px');
          span.style.setProperty('--ram-ty', ty.toFixed(1) + 'px');
          span.style.setProperty('--ram-rot', rot);
          span.style.animationDuration = (650 + Math.random() * 350) + 'ms';
          span.style.animationDelay = (Math.random() * 120) + 'ms';
          frag.appendChild(span);
        }
        thresholdConfetti.appendChild(frag);
        setTimeout(function() {
          if (thresholdConfetti) thresholdConfetti.innerHTML = '';
        }, 1200);
      }

      function cartSpendCents(cart) {
        if (!cart) return 0;
        // Prefer pre-discount merchandise so applied codes don't shrink the meter.
        var spend = 0;
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          var line = items[i];
          spend += Number(
            line.original_line_price != null ? line.original_line_price :
            (line.final_line_price != null ? line.final_line_price : line.line_price)
          ) || 0;
        }
        if (spend > 0) return spend;
        spend = Number(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0;
        if (cart.total_discount > 0 && cart.total_price != null) {
          spend = Math.max(spend, Number(cart.total_price) + Number(cart.total_discount));
        }
        return spend;
      }

      function updateThresholdOffer(cart) {
        var cfg = thresholdConfig();
        if (!thresholdBar) return;
        if (!cfg) {
          thresholdBar.hidden = true;
          setCheckoutLabel(labelCheckout);
          return;
        }
        thresholdBar.hidden = false;

        var subtotal = cartSpendCents(cart);
        var itemCount = cart && cart.item_count ? cart.item_count : 0;
        var remaining = Math.max(0, cfg.threshold - subtotal);
        var pct = itemCount ? Math.min(100, Math.max(0, (subtotal / cfg.threshold) * 100)) : 0;
        var unlocked = remaining === 0 && itemCount > 0;
        var estSaveCents = Math.round(cfg.threshold * (cfg.percent / 100));
        if (unlocked && cart && cart.total_discount > 0) {
          estSaveCents = cart.total_discount;
        } else if (!unlocked && subtotal > 0) {
          estSaveCents = Math.round(Math.max(subtotal, cfg.threshold) * (cfg.percent / 100));
        }
        var amountStr = formatMoney(remaining);
        var saveStr = formatMoney(estSaveCents);
        var msg = '';

        if (!itemCount) {
          msg = decodeAttr(thresholdBar.getAttribute('data-label-empty') || '');
          pct = 0;
          unlocked = false;
        } else if (unlocked) {
          if (cart && cart.total_discount > 0) {
            msg = '✨ ' + fillTemplate(thresholdBar.getAttribute('data-label-unlocked'), { amount: formatMoney(cart.total_discount) });
          } else {
            msg = '✨ ' + (decodeAttr(thresholdBar.getAttribute('data-label-unlocked-fallback') || '') || labelOfferUnlocked);
          }
          pct = 100;
        } else if (remaining <= 5000 || pct >= 90) {
          msg = fillTemplate(thresholdBar.getAttribute('data-label-near'), {
            amount: amountStr,
            save: saveStr,
            percent: cfg.percent
          });
        } else {
          msg = fillTemplate(thresholdBar.getAttribute('data-label-progress'), {
            amount: amountStr,
            save: saveStr,
            percent: cfg.percent
          });
        }

        if (thresholdMsg) thresholdMsg.textContent = msg;

        // Two equal segments map overall 0–100%:
        // halfway (50%) → first seg full / second empty
        // unlock (100%) → both full
        // Re-query fills so theme hot-reload can't leave a stale NodeList.
        var fills = thresholdBar.querySelectorAll('[data-cart-threshold-seg-fill]');
        if (fills.length) {
          var overall = unlocked ? 100 : pct;
          var seg0 = Math.min(100, Math.max(0, overall * 2));            // 0–50 → 0–100
          var seg1 = Math.min(100, Math.max(0, (overall - 50) * 2));     // 50–100 → 0–100
          var widths = [seg0, seg1];
          for (var fi = 0; fi < fills.length; fi++) {
            fills[fi].style.width = (widths[fi] != null ? widths[fi] : 0).toFixed(2) + '%';
          }
          thresholdBar.setAttribute('data-progress', overall.toFixed(1));
        }

        thresholdBar.classList.toggle('is-near', !unlocked && itemCount > 0 && (remaining <= 5000 || pct >= 90));
        thresholdBar.classList.toggle('is-unlocked', unlocked);

        // Foxtale-style milestone gifts: done / current / goal unlocked
        if (thresholdSteps && thresholdSteps.length) {
          var currentAssigned = false;
          thresholdSteps.forEach(function(step) {
            var stepAt = parseInt(step.getAttribute('data-step'), 10) || 0;
            var isGoal = step.classList.contains('is-goal');
            var isDone = false;
            if (stepAt === 0) isDone = itemCount > 0;
            else if (isGoal) isDone = unlocked;
            else isDone = itemCount > 0 && pct >= stepAt;

            var isCurrent = false;
            if (!unlocked && !currentAssigned && !isDone) {
              isCurrent = true;
              currentAssigned = true;
            }

            step.classList.toggle('is-done', isDone);
            step.classList.toggle('is-current', isCurrent);
            step.classList.toggle('is-unlocked', isGoal && unlocked);

            if (isGoal) {
              var goalLabel = step.querySelector('[data-cart-threshold-step-label]');
              if (goalLabel) goalLabel.textContent = cfg.percent + '% off';
            }
          });
        }

        if (checkoutEl) {
          setCheckoutLabel(unlocked ? labelCheckoutUnlocked : labelCheckout);
        }

        if (unlocked && !thresholdCelebrated) {
          thresholdCelebrated = true;
          fireConfetti();
        } else if (!unlocked) {
          thresholdCelebrated = false;
        }

        if (!itemCount) return;

        if (unlocked) {
          var unlockMsg = fillTemplate(thresholdBar.getAttribute('data-label-toast-unlock'), {
            amount: cart && cart.total_discount > 0 ? formatMoney(cart.total_discount) : saveStr,
            percent: cfg.percent
          });
          queueOrShowThresholdToast('unlock', unlockMsg);
        } else if (pct >= 90) {
          queueOrShowThresholdToast('90', fillTemplate(thresholdBar.getAttribute('data-label-toast-90'), {
            amount: amountStr,
            save: saveStr,
            percent: cfg.percent
          }));
        } else if (pct >= 50) {
          queueOrShowThresholdToast('50', fillTemplate(thresholdBar.getAttribute('data-label-toast-50'), {
            amount: amountStr,
            save: saveStr,
            percent: cfg.percent
          }));
        }
      }

      function renderDiscountUI(cart) {
        var apps = cart.cart_level_discount_applications || [];
        var totalDiscount = Number(cart.total_discount) || 0;
        var itemsSubtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
        var original = Number(itemsSubtotal) || 0;
        if (totalDiscount > 0 && cart.total_price != null) {
          original = Math.max(original, Number(cart.total_price) + totalDiscount);
        }

        if (savingsRow) {
          if (totalDiscount > 0 && savingsAmountEl) {
            savingsRow.hidden = false;
            savingsRow.removeAttribute('hidden');
            if (savingsLabelEl) savingsLabelEl.textContent = labelYouSaved;
            savingsAmountEl.textContent = '−' + formatMoney(totalDiscount);
          } else {
            savingsRow.hidden = true;
            savingsRow.setAttribute('hidden', '');
            if (savingsAmountEl) savingsAmountEl.textContent = '';
          }
        }

        if (totalEl) {
          totalEl.textContent = formatMoney(cart.total_price != null ? cart.total_price : itemsSubtotal);
        }
        if (compareEl) {
          if (totalDiscount > 0 && original > cart.total_price) {
            compareEl.hidden = false;
            compareEl.removeAttribute('hidden');
            compareEl.textContent = formatMoney(original);
          } else {
            compareEl.hidden = true;
            compareEl.setAttribute('hidden', '');
            compareEl.textContent = '';
          }
        }
        if (totalRow) {
          totalRow.hidden = false;
          totalRow.removeAttribute('hidden');
        }

        if (apps.length) {
          if (discountFormEl) {
            discountFormEl.hidden = true;
            discountFormEl.setAttribute('hidden', '');
          }
          if (discountAppliedEl) {
            discountAppliedEl.hidden = false;
            discountAppliedEl.removeAttribute('hidden');
            discountAppliedEl.innerHTML =
              apps.map(function(d, i) {
                var title = d.title || (d.discount_application && d.discount_application.title) || 'Discount';
                return '<div class="ram-cart-drawer-code-pill">' +
                  '<span class="ram-cart-drawer-code-pill-text">' +
                    codeCheckSvg('ramCodeCheckClip' + i) +
                    '<span>' + escapeHtml(title) + ' ' + escapeHtml(labelCodeApplied) + '</span>' +
                  '</span>' +
                '</div>';
              }).join('');
          }
        } else {
          if (discountAppliedEl) {
            discountAppliedEl.hidden = true;
            discountAppliedEl.setAttribute('hidden', '');
            discountAppliedEl.innerHTML = '';
          }
          if (discountFormEl) {
            discountFormEl.hidden = false;
            discountFormEl.removeAttribute('hidden');
          }
        }
      }

      function lineHtml(item) {
        if (!item || item.quantity <= 0) return '';
        var imgSrc = cartImageUrl(item.image);
        var img = imgSrc
          ? '<img src="' + escapeHtml(imgSrc) + '" alt="" loading="lazy" decoding="async" width="72" height="72">'
          : '';
        var hasVariant = item.variant_title && item.variant_title !== 'Default Title';
        var sizeInline = hasVariant
          ? '<span class="ram-cart-drawer-line-size">- ' + escapeHtml(item.variant_title) + '</span>'
          : '';
        var unitPrice = formatMoney(item.final_price || item.price);
        var qtySuffix = item.quantity > 1 ? (' X ' + item.quantity) : '';
        var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
        var oldPrice = (item.original_line_price != null && item.original_line_price > linePrice)
          ? '<s class="cart-line-old">' + formatMoney(item.original_line_price) + '</s>'
          : '';
        var maxQty = maxQtyForItem(item);
        return (
          '<article class="ram-cart-drawer-line" data-key="' + escapeHtml(item.key) + '" data-variant-id="' + escapeHtml(item.variant_id || item.id) + '" data-unit-price="' + (item.final_price || item.price) + '" data-qty="' + item.quantity + '"' + (isFinite(maxQty) ? ' data-max-qty="' + maxQty + '"' : '') + '>' +
            '<a href="' + escapeHtml(item.url) + '" class="ram-cart-drawer-line-img">' + img + '</a>' +
            '<div class="ram-cart-drawer-line-body">' +
              '<div class="ram-cart-drawer-line-name">' +
                '<a href="' + escapeHtml(item.url) + '" class="ram-cart-drawer-line-title">' + escapeHtml(item.product_title || item.title) + '</a>' +
                sizeInline +
              '</div>' +
              '<div class="ram-cart-drawer-line-meta">' +
                '<div class="ram-cart-drawer-line-price-wrap">' + oldPrice +
                  '<span class="ram-cart-drawer-line-price">' + unitPrice + qtySuffix + '</span>' +
                '</div>' +
                '<div class="ram-cart-drawer-line-actions">' + qtyCtrlHtml(item.quantity, maxQty) + '</div>' +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }

      function patchLine(lineEl, item) {
        if (!lineEl || !item) return;
        if (item.quantity <= 0) {
          lineEl.remove();
          return;
        }
        var prevQty = parseInt(lineEl.getAttribute('data-qty'), 10) || 0;
        var maxQty = maxQtyForItem(item);
        lineEl.setAttribute('data-qty', String(item.quantity));
        lineEl.setAttribute('data-unit-price', String(item.final_price || item.price));
        if (item.variant_id || item.id) {
          lineEl.setAttribute('data-variant-id', String(item.variant_id || item.id));
        }
        setLineMaxQty(lineEl, maxQty);
        lineEl.classList.remove('is-removing');
        lineEl.style.opacity = '';
        lineEl.style.pointerEvents = '';

        var unitPrice = formatMoney(item.final_price || item.price);
        var qtySuffix = item.quantity > 1 ? (' X ' + item.quantity) : '';
        var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
        var priceWrap = lineEl.querySelector('.ram-cart-drawer-line-price-wrap');
        if (priceWrap) {
          var oldPrice = (item.original_line_price != null && item.original_line_price > linePrice)
            ? '<s class="cart-line-old">' + formatMoney(item.original_line_price) + '</s>'
            : '';
          priceWrap.innerHTML = oldPrice + '<span class="ram-cart-drawer-line-price">' + unitPrice + qtySuffix + '</span>';
        }

        var actions = lineEl.querySelector('.ram-cart-drawer-line-actions');
        if (actions && ((prevQty <= 1) !== (item.quantity <= 1))) {
          actions.innerHTML = qtyCtrlHtml(item.quantity, maxQty);
        } else {
          var display = lineEl.querySelector('[data-drawer-qty-display]');
          if (display) display.textContent = item.quantity;
          updatePlusState(lineEl, item.quantity, maxQty);
        }
      }

      function renderLines(cart) {
        if (!itemsEl) return;
        var items = (cart.items || []).filter(function(item) {
          return item && item.quantity > 0;
        });
        var existing = itemsEl.querySelectorAll('.ram-cart-drawer-line');
        var canPatch = existing.length === items.length &&
          items.length > 0 &&
          Array.prototype.every.call(items, function(item, i) {
            return existing[i] && existing[i].getAttribute('data-key') === item.key;
          });

        if (canPatch) {
          items.forEach(function(item, i) { patchLine(existing[i], item); });
          return;
        }

        var body = itemsEl.closest('.ram-cart-drawer-body') || itemsEl.parentElement;
        var scrollTop = body ? body.scrollTop : 0;
        itemsEl.innerHTML = items.map(lineHtml).join('');
        if (body) body.scrollTop = scrollTop;
      }

      function render(cart) {
        if (!cart) return;
        lastCartFingerprint = cartFingerprint(cart);
        updateCartBadges(cart.item_count);

        if (countEl) {
          countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? labelItem : labelItems);
        }

        updateThresholdOffer(cart);

        if (!cart.item_count) {
          if (itemsEl) itemsEl.innerHTML = '';
          if (emptyEl) {
            emptyEl.hidden = false;
            emptyEl.removeAttribute('hidden');
            var et = emptyEl.querySelector('[data-cart-drawer-empty-title]');
            var ex = emptyEl.querySelector('[data-cart-drawer-empty-text]');
            var es = emptyEl.querySelector('[data-cart-drawer-shop]');
            if (et) et.textContent = decodeAttr(root.getAttribute('data-label-empty-title')) || et.textContent || 'Your cart is empty';
            if (ex) ex.textContent = decodeAttr(root.getAttribute('data-label-empty-text')) || ex.textContent || '';
            if (es) es.textContent = decodeAttr(root.getAttribute('data-label-shop')) || es.textContent || 'Continue shopping';
          }
          if (footEl) {
            footEl.hidden = true;
            footEl.setAttribute('hidden', '');
          }
          setCheckoutLabel(labelCheckout);
          return;
        }

        if (emptyEl) {
          emptyEl.hidden = true;
          emptyEl.setAttribute('hidden', '');
        }
        if (footEl) {
          footEl.hidden = false;
          footEl.removeAttribute('hidden');
        }
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(
            cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price
          );
        }

        renderDiscountUI(cart);
        renderLines(cart);
        applyStockLimitsToLines(cart);
      }

      function recalcOptimisticTotals() {
        if (!itemsEl) return;
        var subtotal = 0;
        var totalCount = 0;
        var lines = itemsEl.querySelectorAll('.ram-cart-drawer-line');
        Array.prototype.forEach.call(lines, function(line) {
          var key = line.getAttribute('data-key');
          var q = (key && pending[key] != null)
            ? pending[key]
            : (parseInt(line.getAttribute('data-qty'), 10) || 0);
          if (q <= 0 || line.classList.contains('is-removing')) return;
          var unit = parseInt(line.getAttribute('data-unit-price'), 10) || 0;
          subtotal += unit * q;
          totalCount += q;
        });

        updateCartBadges(totalCount);
        if (countEl) {
          countEl.textContent = totalCount + ' ' + (totalCount === 1 ? labelItem : labelItems);
        }
        if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
        if (totalEl) totalEl.textContent = formatMoney(subtotal);
        updateThresholdOffer({ items_subtotal_price: subtotal, total_price: subtotal, item_count: totalCount, items: [] });

        if (totalCount === 0) {
          if (footEl) {
            footEl.hidden = true;
            footEl.setAttribute('hidden', '');
          }
          if (emptyEl) {
            emptyEl.hidden = false;
            emptyEl.removeAttribute('hidden');
          }
        } else {
          if (footEl) {
            footEl.hidden = false;
            footEl.removeAttribute('hidden');
          }
          if (emptyEl) {
            emptyEl.hidden = true;
            emptyEl.setAttribute('hidden', '');
          }
        }
      }

      function scheduleSync() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(flush, 280);
      }

      function flush() {
        if (syncing) { scheduleSync(); return; }
        var keys = Object.keys(pending);
        if (!keys.length) return;
        var updates = {};
        keys.forEach(function(k) {
          updates[k] = pending[k];
          delete pending[k];
        });
        syncing = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: 'ram-cart-drawer' })
        })
        .then(function(r) {
          return r.json().then(function(data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function(cart) {
          syncing = false;
          if (cart.sections && cart.sections['ram-cart-drawer']) {
            mergeVariantStock(parseStockSeedFromHtml(cart.sections['ram-cart-drawer']));
          }
          render(cart);
          if (Object.keys(pending).length) flush();
        })
        .catch(function(err) {
          syncing = false;
          if (err && (err.description || err.message)) {
            showToast(err.description || err.message);
          }
          refreshStockSeedFromSection()
            .then(function() { return reconcileCartStock(); })
            .then(function(result) {
              notifyStockChanges(result);
              render(result.cart);
            })
            .catch(function() {
              fetch('/cart.js').then(function(r) { return r.json(); }).then(render);
            });
        });
      }

      function queueChange(lineEl, qty) {
        if (qty < 0) qty = 0;
        var maxQty = lineMaxQty(lineEl);
        if (qty > 0 && qty > maxQty) qty = maxQty;
        var key = lineEl.getAttribute('data-key');
        if (!key) return;
        var prevQty = parseInt(lineEl.getAttribute('data-qty'), 10) || 0;
        lineEl.setAttribute('data-qty', String(qty));

        if (qty === 0) {
          lineEl.classList.add('is-removing');
          lineEl.style.opacity = '.35';
          lineEl.style.pointerEvents = 'none';
        } else {
          lineEl.classList.remove('is-removing');
          lineEl.style.opacity = '';
          lineEl.style.pointerEvents = '';
          var actions = lineEl.querySelector('.ram-cart-drawer-line-actions');
          if (actions && ((prevQty <= 1) !== (qty <= 1))) {
            actions.innerHTML = qtyCtrlHtml(qty, maxQty);
          } else {
            var display = lineEl.querySelector('[data-drawer-qty-display]');
            if (display) display.textContent = qty;
            updatePlusState(lineEl, qty, maxQty);
          }
          var unit = parseInt(lineEl.getAttribute('data-unit-price'), 10);
          var priceEl = lineEl.querySelector('.ram-cart-drawer-line-price');
          if (priceEl && !isNaN(unit)) {
            priceEl.textContent = formatMoney(unit) + (qty > 1 ? (' X ' + qty) : '');
          }
        }

        pending[key] = qty;
        recalcOptimisticTotals();
        scheduleSync();
      }

      function openWithCart(cart) {
        render(cart);
        open();
      }

      function setItemsLoading(on) {
        if (itemsEl) itemsEl.classList.toggle('is-loading', !!on);
      }

      function fetchAndOpen() {
        open();
        setItemsLoading(true);
        return fetch('/cart.js?sections=ram-cart-drawer')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            if (cart.sections && cart.sections['ram-cart-drawer']) {
              mergeVariantStock(parseStockSeedFromHtml(cart.sections['ram-cart-drawer']));
            }
            openWithCart(cart);
            setItemsLoading(false);
            return reconcileCartStock(cart).then(function(result) {
              notifyStockChanges(result);
              if (result && result.changed) render(result.cart);
              return result.cart || cart;
            });
          })
          .catch(function() {
            setItemsLoading(false);
            return reconcileCartStock()
              .then(function(result) {
                notifyStockChanges(result);
                openWithCart(result.cart);
                return result.cart;
              });
          });
      }

      root.querySelectorAll('[data-cart-drawer-close]').forEach(function(el) {
        el.addEventListener('click', close);
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });

      if (itemsEl) {
        // Delegate from panel root so qty controls stay clickable even after re-renders
        root.addEventListener('click', function(e) {
          var plusBtn = e.target.closest('[data-drawer-plus]');
          var minusBtn = e.target.closest('[data-drawer-minus]');
          var removeBtn = e.target.closest('[data-drawer-remove]');
          if (!plusBtn && !minusBtn && !removeBtn) return;
          if (!itemsEl.contains(plusBtn || minusBtn || removeBtn)) return;

          e.preventDefault();
          e.stopPropagation();

          var line = e.target.closest('.ram-cart-drawer-line');
          if (!line || !itemsEl.contains(line)) return;

          var qty = parseInt(line.getAttribute('data-qty'), 10);
          if (isNaN(qty)) {
            var disp = line.querySelector('[data-drawer-qty-display]');
            qty = parseInt(disp && disp.textContent, 10) || 0;
          }

          if (minusBtn) queueChange(line, Math.max(1, qty - 1));
          else if (plusBtn) {
            if (plusBtn.disabled || plusBtn.getAttribute('aria-disabled') === 'true') return;
            var maxQty = lineMaxQty(line);
            if (qty >= maxQty) {
              updatePlusState(line, qty, maxQty);
              return;
            }
            queueChange(line, qty + 1);
          }
          else if (removeBtn) queueChange(line, 0);
        });
      }

      if (discountBtn && discountInput) {
        discountBtn.addEventListener('click', function() {
          applyDiscountCode(discountInput.value);
        });
        discountInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            applyDiscountCode(discountInput.value);
          }
        });
      }

      // Seed empty-state labels once
      var et = root.querySelector('[data-cart-drawer-empty-title]');
      var ex = root.querySelector('[data-cart-drawer-empty-text]');
      var es = root.querySelector('[data-cart-drawer-shop]');
      if (et && !et.textContent) et.textContent = decodeAttr(root.getAttribute('data-label-empty-title')) || '';
      if (ex && !ex.textContent) ex.textContent = decodeAttr(root.getAttribute('data-label-empty-text')) || '';
      if (es && !es.textContent) es.textContent = decodeAttr(root.getAttribute('data-label-shop')) || '';

      // After discount redirect, reopen drawer and validate code
      try {
        var shouldOpen = sessionStorage.getItem(STORAGE_OPEN) === '1';
        var pendingCode = sessionStorage.getItem(STORAGE_PENDING);
        if (shouldOpen) sessionStorage.removeItem(STORAGE_OPEN);
        if (shouldOpen || pendingCode) {
          fetchAndOpen().then(function(cart) {
            if (!pendingCode) return;
            sessionStorage.removeItem(STORAGE_PENDING);
            var apps = (cart.cart_level_discount_applications || []).map(function(d) {
              return String(d.title || '').toLowerCase();
            });
            var matched = apps.some(function(t) { return t === pendingCode.toLowerCase(); });
            if (!matched && discountError && discountInput) {
              discountError.textContent = labelInvalid;
              discountError.hidden = false;
              discountInput.value = pendingCode;
              if (discountFormEl) discountFormEl.hidden = false;
            }
          });
        }
      } catch (err) {}

      return { open: open, close: close, render: render, openWithCart: openWithCart, fetchAndOpen: fetchAndOpen };
    })();

    window.ramCartDrawer = ramCartDrawer;

    // Header / bottom-nav cart icons → open drawer (skip on cart page)
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a.cart-link');
      if (!link) return;
      if (document.body.classList.contains('template-cart')) return;
      if (!ramCartDrawer) return;
      e.preventDefault();
      ramCartDrawer.fetchAndOpen();
    });

    // Checkout: sync stock first so OOS lines can't proceed
    document.addEventListener('click', function(e) {
      var checkoutEl = e.target.closest('[data-cart-drawer-checkout], .cart-checkout');
      if (!checkoutEl) return;
      // Let form submit handler on cart page own .cart-checkout buttons
      if (checkoutEl.matches('.cart-checkout') && checkoutEl.closest('#ramCartForm')) return;
      e.preventDefault();
      var href = checkoutEl.getAttribute('href') || '/checkout';
      checkoutEl.setAttribute('aria-busy', 'true');
      reconcileCartStock()
        .then(function(result) {
          notifyStockChanges(result);
          if (ramCartDrawer && result.changed) ramCartDrawer.render(result.cart);
          if (!result.cart.item_count) {
            showToast(stockLabel('stock-empty', 'Your cart no longer has available items.'));
            return;
          }
          window.location.href = href;
        })
        .catch(function() { window.location.href = href; })
        .finally(function() { checkoutEl.removeAttribute('aria-busy'); });
    });

    // Intercept Add to Cart / Buy Now forms
    document.addEventListener('submit', function(e) {
      if(e.target.matches('.quick-add')) {
        e.preventDefault();
        var form = e.target;
        // Prefer submitter; fall back to which button is "active" / last clicked.
        var submitter = e.submitter || form.querySelector('button[type="submit"]:focus') || form.querySelector('.btn-add, .add');
        var isCheckout = !!(submitter && submitter.name === 'checkout');
        var btn = isCheckout
          ? (submitter.matches('.btn-buy, .buy-now') ? submitter : form.querySelector('.btn-buy, .buy-now'))
          : (submitter && submitter.matches('.btn-add, .add') ? submitter : form.querySelector('.btn-add, .add'));
        var mobileAdd = document.getElementById('pdpMobileAdd');
        var mobileBuy = document.getElementById('pdpMobileBuy');
        var mobileBtn = isCheckout ? mobileBuy : mobileAdd;
        var originalText;
        var originalMobileHtml;

        function setBusy(busy) {
          if (btn) {
            if (busy) {
              originalText = btn.innerHTML;
              btn.innerHTML = isCheckout ? 'Processing...' : 'Adding...';
              btn.disabled = true;
            } else {
              btn.innerHTML = originalText;
              btn.disabled = false;
            }
          }
          if (mobileBtn) {
            if (busy) {
              originalMobileHtml = mobileBtn.innerHTML;
              mobileBtn.disabled = true;
              var label = mobileBtn.querySelector('.pdp-mobile-bar-btn__label');
              if (label) label.textContent = isCheckout ? 'Processing...' : 'Adding...';
              else mobileBtn.textContent = isCheckout ? 'Processing...' : 'Adding...';
            } else {
              mobileBtn.disabled = false;
              if (originalMobileHtml != null) mobileBtn.innerHTML = originalMobileHtml;
            }
          }
        }

        function variantIdFromForm() {
          var sel = form.querySelector('[name="id"]');
          if (!sel) return null;
          return String(sel.value || '');
        }

        function addToCart() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          }).then(function(response) {
            return response.json().then(function(data) {
              if (!response.ok) { throw new Error(data.description || data.message || 'add-failed'); }
              return data;
            });
          });
        }

        setBusy(true);

        // Buy Now: if this variant is already in the cart, go to checkout without
        // adding another unit (Shopify /cart/add.js always increments).
        if (isCheckout) {
          var variantId = variantIdFromForm();
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var alreadyInCart = (cart.items || []).some(function(item) {
                return String(item.variant_id) === variantId || String(item.id) === variantId;
              });
              var goCheckout = function() {
                return reconcileCartStock().then(function(result) {
                  notifyStockChanges(result);
                  if (!result.cart.item_count) {
                    showToast(stockLabel('stock-empty', 'Your cart no longer has available items.'));
                    setBusy(false);
                    return;
                  }
                  window.location.href = '/checkout';
                });
              };
              if (alreadyInCart) return goCheckout();
              return addToCart().then(goCheckout);
            })
            .catch(function(error) {
              console.error('Error:', error);
              showToast(error.message || 'Error going to checkout');
              setBusy(false);
            });
          return;
        }

        // Instant feedback: open drawer as soon as ATC starts (don't wait for 2 network hops).
        if (ramCartDrawer) {
          ramCartDrawer.open();
          var itemsPending = document.querySelector('[data-cart-drawer-items]');
          if (itemsPending) itemsPending.classList.add('is-loading');
        }

        addToCart()
        .then(function() {
          return fetch('/cart.js?sections=ram-cart-drawer')
            .then(function(res){ return res.json(); })
            .then(function(cart) {
              if (cart.sections && cart.sections['ram-cart-drawer']) {
                mergeVariantStock(parseStockSeedFromHtml(cart.sections['ram-cart-drawer']));
              }
              updateCartBadges(cart.item_count);
              if (ramCartDrawer) ramCartDrawer.openWithCart(cart);
              else showToast('Added to cart!');
              try {
                document.dispatchEvent(new CustomEvent('ram:cart-added', { detail: { cart: cart } }));
              } catch (err) {}
            })
            .finally(function() {
              var itemsEl = document.querySelector('[data-cart-drawer-items]');
              if (itemsEl) itemsEl.classList.remove('is-loading');
              setBusy(false);
            });
        })
        .catch(function(error) {
          console.error('Error:', error);
          showToast(error.message || 'Error adding to cart');
          var itemsEl = document.querySelector('[data-cart-drawer-items]');
          if (itemsEl) itemsEl.classList.remove('is-loading');
          setBusy(false);
        });
      }
    });

    // ---- Product page variant selector (size options -> variant id + price) ----
    (function(){
      var dataEl = document.getElementById('pdpVariants');
      var sel = document.getElementById('variantSelect');
      if(!dataEl || !sel) return;
      var form = sel.closest('form.quick-add');
      if(!form) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }
      if(!variants || !variants.length) return;

      var priceEl = document.getElementById('pdpPrice');
      var priceWrap = form.querySelector('.pdp-price');
      var addBtn = form.querySelector('.btn-add');
      var buyBtn = form.querySelector('.btn-buy');
      var mobileBar = document.getElementById('pdpMobileBar');
      var mobilePrice = document.getElementById('pdpMobilePrice');
      var mobileOld = document.getElementById('pdpMobileOld');
      var mobileSize = document.getElementById('pdpMobileSize');
      var mobileAdd = document.getElementById('pdpMobileAdd');
      var mobileBuy = document.getElementById('pdpMobileBuy');
      var mobileOos = document.getElementById('pdpMobileOos');
      var desktopOos = document.getElementById('pdpOosBtn');
      var groups = form.querySelectorAll('.size-opts');
      var mainImg = document.getElementById('pdpMainImage');

      function selectedValues(){
        var vals = [];
        groups.forEach(function(g){
          var checked = g.querySelector('input[type=radio]:checked');
          if(checked) vals.push(checked.value);
        });
        return vals;
      }

      function matchVariant(vals){
        return variants.filter(function(v){
          if(!v.options || v.options.length !== vals.length) return false;
          return v.options.every(function(o, i){ return String(o) === String(vals[i]); });
        })[0];
      }

      function setOldPrice(html){
        if(priceWrap){
          var old = priceWrap.querySelector('.old');
          if(html){
            if(!old){ old = document.createElement('span'); old.className = 'old'; priceWrap.appendChild(old); }
            old.innerHTML = html;
            old.style.display = '';
          } else if(old){
            old.style.display = 'none';
          }
        }
        if(mobileOld){
          if(html){
            mobileOld.innerHTML = html;
            mobileOld.hidden = false;
            mobileOld.removeAttribute('hidden');
          } else {
            mobileOld.hidden = true;
            mobileOld.setAttribute('hidden', '');
          }
        }
      }

      function setVisible(el, show){
        if(!el) return;
        if(show){
          el.hidden = false;
          el.removeAttribute('hidden');
          el.classList.remove('is-hidden');
        } else {
          el.hidden = true;
          el.setAttribute('hidden', '');
          el.classList.add('is-hidden');
        }
      }

      function restoreLabel(btn){
        if(!btn) return;
        var text = btn.getAttribute('data-label-available') || '';
        var labelEl = btn.querySelector('.pdp-mobile-bar-btn__label');
        if(labelEl){
          labelEl.textContent = text;
        } else if(btn.querySelector('svg')){
          var icon = btn.querySelector('svg');
          btn.textContent = '';
          btn.appendChild(icon);
          btn.appendChild(document.createTextNode(' ' + text));
        } else {
          btn.textContent = text;
        }
      }

      function update(){
        var v = matchVariant(selectedValues());
        if(!v) return;
        sel.value = v.id;
        if(priceEl && v.price) priceEl.innerHTML = v.price;
        if(mobilePrice && v.price) mobilePrice.innerHTML = v.price;
        if(mobileSize && v.options && v.options.length) mobileSize.textContent = v.options.join(' / ');
        setOldPrice(v.compare_at);

        if(mainImg && v.image){
          mainImg.src = v.image;
          var vPath = v.image.split('?')[0];
          document.querySelectorAll('.pdp-thumbs .th').forEach(function(t){
            var timg = t.querySelector('img');
            var match = timg && timg.src.split('?')[0] === vPath;
            t.classList.toggle('active', !!match);
          });
        }

        var available = !!v.available;
        if(available){
          if(addBtn){ addBtn.disabled = false; addBtn.classList.remove('sold-out'); restoreLabel(addBtn); }
          if(buyBtn){ buyBtn.disabled = false; buyBtn.classList.remove('sold-out'); restoreLabel(buyBtn); }
          if(mobileAdd){ mobileAdd.disabled = false; mobileAdd.classList.remove('sold-out'); restoreLabel(mobileAdd); }
          if(mobileBuy){ mobileBuy.disabled = false; mobileBuy.classList.remove('sold-out'); restoreLabel(mobileBuy); }
          setVisible(addBtn, true);
          setVisible(buyBtn, true);
          setVisible(mobileAdd, true);
          setVisible(mobileBuy, true);
          setVisible(desktopOos, false);
          setVisible(mobileOos, false);
        } else {
          setVisible(addBtn, false);
          setVisible(buyBtn, false);
          setVisible(mobileAdd, false);
          setVisible(mobileBuy, false);
          setVisible(desktopOos, true);
          setVisible(mobileOos, true);
        }
      }

      form.addEventListener('change', function(e){
        if(!e.target.matches('.size-opts input[type=radio]')) return;
        var group = e.target.closest('.size-opts');
        if(group){
          group.querySelectorAll('.sz').forEach(function(l){ l.classList.remove('active'); });
          var lbl = e.target.closest('.sz');
          if(lbl) lbl.classList.add('active');
          // Reflect the chosen value in the "Size: Medium" header label
          var idx = group.getAttribute('data-option-index');
          var out = form.querySelector('[data-opt-selected="' + idx + '"]');
          if(out) out.textContent = e.target.value;
        }
        update();
      });

      // Sync initial state (in case selected option differs from first variant)
      update();

      if(mobileAdd && addBtn){
        mobileAdd.addEventListener('click', function(){
          if(mobileAdd.disabled || mobileAdd.hidden) return;
          // requestSubmit preserves submitter (needed to tell ATC vs Buy Now apart)
          if (typeof form.requestSubmit === 'function') form.requestSubmit(addBtn);
          else addBtn.click();
        });
      }

      if(mobileBuy && buyBtn){
        mobileBuy.addEventListener('click', function(){
          if(mobileBuy.disabled || mobileBuy.hidden) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(buyBtn);
          else buyBtn.click();
        });
      }

      // Thumbnail click swaps main image
      if(mainImg){
        document.querySelectorAll('.pdp-thumbs .th').forEach(function(t){
          t.addEventListener('click', function(){
            var timg = t.querySelector('img');
            if(!timg) return;
            mainImg.src = timg.src.replace(/width=\d+/g, 'width=900').replace(/height=\d+/g, 'height=900');
            document.querySelectorAll('.pdp-thumbs .th').forEach(function(x){ x.classList.remove('active'); });
            t.classList.add('active');
          });
        });
      }
    })();

    // ---- Product detail tabs (Description / Specifications) ----
    (function(){
      var tabsWrap = document.querySelector('.pdp-details .tabs');
      if(!tabsWrap) return;
      var container = tabsWrap.closest('.pdp-details');

      function activateTab(targetId){
        if(!targetId) return;
        var tab = tabsWrap.querySelector('[data-tab-target="' + targetId + '"]');
        if(!tab) return;
        tabsWrap.querySelectorAll('.tab').forEach(function(t){
          var on = t === tab;
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        container.querySelectorAll('.tab-panel').forEach(function(p){
          var on = p.id === targetId;
          p.classList.toggle('active', on);
          p.hidden = !on;
        });
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      tabsWrap.addEventListener('click', function(e){
        var tab = e.target.closest('.tab');
        if(!tab) return;
        activateTab(tab.getAttribute('data-tab-target'));
      });

      document.querySelectorAll('[data-tab-jump]').forEach(function(btn){
        btn.addEventListener('click', function(){
          activateTab(btn.getAttribute('data-tab-jump'));
        });
      });
    })();

    // ---- Click Intercepts (Wishlist, etc) ----
    document.addEventListener('click', function(e){
      var notify = e.target.closest('[data-notify]');
      if(notify){ e.preventDefault(); showToast("We'll notify you when available"); return; }
      
      var wish = e.target.closest('[data-wish]');
      if(wish){
        e.preventDefault();
        e.stopPropagation();
        wish.classList.toggle('active');
        var isActive = wish.classList.contains('active');
        wish.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        wish.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
        var name = wish.getAttribute('data-name') || 'Item';
        var handle = wish.getAttribute('data-handle') || name;
        showToast(isActive ? 'Added to wishlist' : 'Removed from wishlist');

        var w = readWish();
        if(isActive) {
          if(!w.some(function(i){ return wishKey(i) === handle; })) {
            w.push({ handle: handle, name: name, url: wish.getAttribute('data-url') || ('/products/'+handle), price: wish.getAttribute('data-price') || '', image: wish.getAttribute('data-image') || '' });
          }
        } else {
          w = w.filter(function(i){ return wishKey(i) !== handle; });
        }
        localStorage.setItem('ramWish', JSON.stringify(w));
        updateWishCount(w.length);
        return;
      }
    });

    // ---- Wishlist storage helpers ----
    function wishKey(i){ return (i && typeof i === 'object') ? i.handle : i; }
    function readWish(){ try { return JSON.parse(localStorage.getItem('ramWish') || '[]'); } catch(e){ return []; } }
    function esc(s){ return String(s||'').replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
    function syncWishHearts(keys){
      document.querySelectorAll('[data-wish]').forEach(function(btn){
        var handle = btn.getAttribute('data-handle') || btn.getAttribute('data-name');
        var active = keys.indexOf(handle) !== -1;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }
    function updateWishCount(n){ document.querySelectorAll('[data-wish-count]').forEach(function(b){ b.textContent = n; b.style.display = n > 0 ? 'flex' : 'none'; }); }

    // ---- Mobile menu ----
    var mt=document.getElementById('menuToggle'), mm=document.getElementById('mobileMenu'), ov=document.getElementById('menuOverlay'), mc=document.getElementById('menuClose');
    function openMenu(){ mm&&mm.classList.add('open'); ov&&ov.classList.add('open'); }
    function closeMenu(){ mm&&mm.classList.remove('open'); ov&&ov.classList.remove('open'); }
    mt&&mt.addEventListener('click',openMenu); mc&&mc.addEventListener('click',closeMenu); ov&&ov.addEventListener('click',closeMenu);

    // Initialize wishlist active states + count on load
    document.addEventListener('DOMContentLoaded', function() {
      var w = readWish().filter(function(i){ return i && typeof i === 'object' && i.handle; });
      var keys = w.map(wishKey);
      syncWishHearts(keys);
      updateWishCount(w.length);
      renderWishlistPage();
    });

    // ---- Wishlist page renderer (reads localStorage, builds product cards) ----
    function renderWishlistPage(){
      var container = document.querySelector('[data-wishlist-container]');
      if(!container) return;
      var w = readWish().filter(function(i){ return i && typeof i === 'object' && i.handle; });
      if(!w.length){
        container.innerHTML = '<div class="wish-empty"><svg viewBox="0 0 24 24" width="52" height="52" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg><h3>Your wishlist is empty</h3><p>Tap the heart on any product to save it here.</p><a href="/collections/all" class="wish-shop">Continue Shopping</a></div>';
        return;
      }
      var html = '<div class="wish-grid">';
      w.forEach(function(p){
        html += '<div class="wish-card" data-wish-item="'+esc(p.handle)+'">'
          + '<a href="'+esc(p.url)+'" class="wish-img">'+(p.image ? '<img src="'+esc(p.image)+'" alt="'+esc(p.name)+'" loading="lazy">' : '')+'</a>'
          + '<button class="wish-remove" data-wish-remove="'+esc(p.handle)+'" aria-label="Remove from wishlist">&times;</button>'
          + '<div class="wish-body"><a href="'+esc(p.url)+'" class="wish-name">'+esc(p.name)+'</a>'
          + '<div class="wish-price">'+(p.price ? esc(p.price) : '')+'</div>'
          + '<a href="'+esc(p.url)+'" class="wish-view">View Product</a></div>'
          + '</div>';
      });
      html += '</div>';
      container.innerHTML = html;
      container.querySelectorAll('[data-wish-remove]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var h = btn.getAttribute('data-wish-remove');
          var list = readWish().filter(function(i){ return wishKey(i) !== h; });
          localStorage.setItem('ramWish', JSON.stringify(list));
          var keys = list.map(wishKey);
          syncWishHearts(keys);
          updateWishCount(list.length);
          renderWishlistPage();
          showToast('Removed from wishlist');
        });
      });
    }
    // ---- Prefetch internal links on intent (hover / touch) for instant navigation ----
    (function(){
      var prefetched = {};
      var hoverTimer = null;

      function eligible(a){
        if(!a || !a.href) return false;
        if(a.origin !== location.origin) return false;            // same-site only
        if(a.hasAttribute('download') || a.target === '_blank') return false;
        var url = a.pathname + a.search;
        if(prefetched[url]) return false;
        if(/\/(cart|checkout|account|logout)(\/|$|\?)/.test(a.pathname)) return false; // skip stateful/auth
        if(/\/(cart\/add|cart\/change)/.test(a.pathname)) return false;
        if(a.getAttribute('href') && a.getAttribute('href').charAt(0) === '#') return false;
        if(a.pathname === location.pathname && a.search === location.search) return false;
        return true;
      }

      function prefetch(a){
        var url = a.pathname + a.search;
        if(prefetched[url]) return;
        prefetched[url] = true;
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.href = a.href;
        l.as = 'document';
        document.head.appendChild(l);
      }

      // Desktop: hover intent (small delay so quick fly-overs don't prefetch everything)
      document.addEventListener('mouseover', function(e){
        var a = e.target.closest && e.target.closest('a');
        if(!eligible(a)) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function(){ prefetch(a); }, 60);
      });
      document.addEventListener('mouseout', function(){ clearTimeout(hoverTimer); });

      // Mobile: touchstart fires ~100-300ms before click — prefetch immediately
      document.addEventListener('touchstart', function(e){
        var a = e.target.closest && e.target.closest('a');
        if(eligible(a)) prefetch(a);
      }, { passive: true });
    })();

    // ---- Pin fixed bottom chrome to visual viewport (iOS Chrome scroll gap) ----
    (function(){
      var vv = window.visualViewport;
      if(!vv) return;
      var ticking = false;
      var root = document.documentElement;
      function sync(){
        ticking = false;
        // Positive = browser chrome eating the bottom (lift bars). Negative = layout lag after chrome hides (push bars down into the gap).
        var shift = Math.round(window.innerHeight - vv.height - vv.offsetTop);
        if(Math.abs(shift) < 1) shift = 0;
        root.style.setProperty('--ram-vv-bottom', shift + 'px');
      }
      function onChange(){
        if(ticking) return;
        ticking = true;
        requestAnimationFrame(sync);
      }
      vv.addEventListener('resize', onChange);
      vv.addEventListener('scroll', onChange);
      window.addEventListener('orientationchange', onChange);
      window.addEventListener('pageshow', onChange);
      sync();
    })();

    // ---- Meta in-app browser tip ----
    (function(){
      var el = document.getElementById('ramMetaIab');
      if (!el) return;
      var key = el.getAttribute('data-storage-key') || 'ram_meta_iab_dismiss_v1';
      try {
        if (localStorage.getItem(key) === '1') return;
      } catch (e) {}
      var ua = navigator.userAgent || '';
      var isMeta =
        /FBAN|FBAV|FB_IAB|Instagram|Messenger|IABMV|Twitter|Line\//i.test(ua) ||
        (/\bFB[\w]*\//i.test(ua) && /Mobile/i.test(ua));
      if (!isMeta) return;
      el.hidden = false;
      el.classList.add('is-visible');
      var btn = el.querySelector('[data-meta-iab-dismiss]');
      if (btn) {
        btn.addEventListener('click', function(){
          el.classList.remove('is-visible');
          el.hidden = true;
          try { localStorage.setItem(key, '1'); } catch (e) {}
        });
      }
    })();

    // ---- WhatsApp deep-link (product + cart context) ----
    (function(){
      var fab = document.getElementById('ramWhatsAppFab');
      if (!fab) return;
      var base = fab.getAttribute('data-wa-base') || 'https://wa.me/97466097444';
      var defaultMsg = fab.getAttribute('data-wa-default') || 'Hi Ramillette! I have a question about your products.';
      var productTitle = fab.getAttribute('data-wa-product-title') || '';
      var productUrl = fab.getAttribute('data-wa-product-url') || '';
      var cartIntro = fab.getAttribute('data-wa-cart-intro') || 'Hi Ramillette! I\'d like help with my order:';
      var productTpl = fab.getAttribute('data-wa-product-tpl') || 'Hi Ramillette! I\'m interested in __TITLE__ — __URL__';
      var moneyFmt = (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney.bind(Shopify) : null;
      var moneyFormat = (window.theme && theme.moneyFormat) || (window.Shopify && Shopify.money_format) || '{{amount}} QAR';
      var lastCart = null;

      function money(cents){
        if (typeof cents !== 'number') return '';
        if (moneyFmt) {
          try { return moneyFmt(cents, moneyFormat); } catch (e) {}
        }
        return 'QAR ' + (cents / 100).toFixed(2);
      }

      function buildHref(text){
        var sep = base.indexOf('?') >= 0 ? '&' : '?';
        return base + sep + 'text=' + encodeURIComponent(text);
      }

      function selectedSizeLabel(){
        var checked = document.querySelector('.size-opts input[type=radio]:checked');
        return checked ? checked.value : '';
      }

      function productMessage(){
        if (!productTitle) return '';
        var title = productTitle;
        var size = selectedSizeLabel();
        if (size) title = title + ' (' + size + ')';
        var url = productUrl || (window.location && window.location.href) || '';
        return productTpl.replace('__TITLE__', title).replace('__URL__', url)
          .replace(/\{\{\s*title\s*\}\}/gi, title)
          .replace(/\{\{\s*url\s*\}\}/gi, url);
      }

      function cartMessage(cart){
        if (!cart || !cart.items || !cart.items.length) return '';
        var lines = [cartIntro];
        cart.items.forEach(function(item){
          var name = item.product_title || item.title || 'Item';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '';
          lines.push('- ' + name + variant + ' × ' + item.quantity);
        });
        if (typeof cart.total_price === 'number') {
          lines.push('Cart total: ' + money(cart.total_price));
        }
        lines.push('Page: ' + (window.location.href || ''));
        return lines.join('\n');
      }

      function syncLinks(cart){
        if (cart) lastCart = cart;
        var msg = cartMessage(lastCart) || productMessage() || defaultMsg;
        var href = buildHref(msg);
        fab.setAttribute('href', href);
        document.querySelectorAll('a[aria-label="WhatsApp"]').forEach(function(a){
          if (a !== fab) a.setAttribute('href', href);
        });
      }

      function refreshFromCart(){
        return fetch('/cart.js')
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(cart){ if (cart) syncLinks(cart); })
          .catch(function(){ syncLinks(null); });
      }

      syncLinks(null);
      refreshFromCart();
      document.addEventListener('ram:cart-added', function(e){
        syncLinks(e && e.detail && e.detail.cart ? e.detail.cart : null);
        if (!(e && e.detail && e.detail.cart)) refreshFromCart();
      });
      document.addEventListener('change', function(e){
        if (e.target && e.target.matches && e.target.matches('.size-opts input[type=radio]')) {
          syncLinks(lastCart);
        }
      });
      // After drawer qty / line changes, cart badge updates — refresh WA when badge text changes.
      var badge = document.querySelector('[data-cart-count]');
      if (badge && typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function(){ refreshFromCart(); });
        mo.observe(badge, { childList: true, characterData: true, subtree: true });
      }
    })();

    // ---- Hero carousel ----
    var hc=document.getElementById('heroCarousel');
    if(hc){
      var track=hc.querySelector('.hero-track'), slides=hc.querySelectorAll('.hero-slide'), dots=hc.querySelectorAll('[data-hero-dot]'), i=0, timer;
      function go(n){ i=(n+slides.length)%slides.length; track.style.transform='translateX(-'+(i*100)+'%)'; dots.forEach(function(d,x){d.classList.toggle('active',x===i);}); }
      hc.querySelector('[data-hero="next"]')?.addEventListener('click',function(){go(i+1);reset();});
      hc.querySelector('[data-hero="prev"]')?.addEventListener('click',function(){go(i-1);reset();});
      dots.forEach(function(d){ d.addEventListener('click',function(){go(+d.getAttribute('data-hero-dot'));reset();}); });
      function reset(){ clearInterval(timer); timer=setInterval(function(){go(i+1);},5000); }
      reset();
    }
})();
